import { all } from 'redux-saga/effects';
import jobs from './jobs';

export const jobsSaga = function* root() {
  yield all([jobs()]);
};
